import React, { createContext, useReducer, useContext, useMemo } from "react";
import { calculatorReducer } from "./calculatorReducer";
import { initialStore } from "./initialStore";

export const CalculatorContext = createContext(null);

export const CalculatorProvider = ({ children }) => {
  const [state, dispatch] = useReducer(calculatorReducer, initialStore);

  const value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <CalculatorContext.Provider value={value}>
      {children}
    </CalculatorContext.Provider>
  );
};
